<mat-form-field [appearance]="appearance" [floatLabel]="label ? 'auto' : 'always'" class="w-full">
  <mat-label [class.disable-label]="autocompleteControl.disabled && (_currentThemeSubject | async) === 'dark'">
    {{ label }}
  </mat-label>
  <fb-anex
    *ngIf="prefix"
    matPrefix
    [config]="prefix"
    [control]="control"
    [templates]="templates"
    position="start"
  ></fb-anex>
  <input
    [required]="required"
    matInput
    fbDisableAutocomplete
    [placeholder]="placeholder"
    [formControl]="autocompleteControl"
    [matAutocomplete]="auto"
    [fbDisableControl]="disable || ngControl.disabled"
    [readonly]="readonly"
    #trigger="matAutocompleteTrigger"
    (blur)="onInputBlur()"
    (focusout)="onTouched()"
    (keyup.enter)="$event.stopPropagation(); $event.preventDefault()"
    (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
    (keydown.tab)="add()"
  />
  <ng-container *ngIf="(loading.active$ | async) === false; else showLoader">
    <ng-container *ngIf="suffix; else showButtons">
      <fb-anex
        matSuffix
        [config]="suffix"
        [control]="ngControl.control"
        [templates]="templates"
        position="end"
      ></fb-anex>
    </ng-container>
    <ng-template #showButtons>
      <button
        *ngIf="allowEmpty && value !== undefined && value !== null"
        tabindex="-1"
        type="button"
        mat-icon-button
        matSuffix
        (click)="onClear(); onTouched(); trigger.closePanel(); $event.stopPropagation(); $event.preventDefault()"
        [disabled]="disable || readonly || ngControl.disabled"
      >
        <mat-icon [inline]="true" class="icon-button">clear</mat-icon>
      </button>
      <button
        *ngIf="value === undefined || value === null || !allowEmpty"
        tabindex="-1"
        type="button"
        mat-icon-button
        matSuffix
        (click)="
          trigger.panelOpen ? trigger.closePanel() : trigger.openPanel();
          $event.stopPropagation();
          $event.preventDefault()
        "
        [disabled]="disable || readonly || ngControl.disabled"
      >
        <ng-container *ngIf="!trigger.panelOpen; else upIcon">
          <mat-icon [inline]="true" class="icon-button">keyboard_arrow_down</mat-icon>
        </ng-container>
        <ng-template #upIcon>
          <mat-icon [inline]="true" class="icon-button" message="">keyboard_arrow_up</mat-icon>
        </ng-template>
      </button>
    </ng-template>
  </ng-container>
  <ng-template #showLoader>
    <fb-loader class="position-relative loader" [size]="20" [message]="undefined" matSuffix></fb-loader>
  </ng-template>

  <mat-autocomplete
    autoActiveFirstOption
    #auto="matAutocomplete"
    fbAutocompleteScroll
    [class]="(_currentThemeSubject | async) === 'dark' ? 'dark-theme-autocomplate-list' : ''"
    classList="fb-autocomplete"
    [displayWith]="displayValue"
    [endOfData]="endOfData"
    (scrollEvent)="loadNext()"
    (optionSelected)="onOptionSelected($event)"
  >
    <mat-progress-bar class="position-sticky top-0" mode="buffer" *ngIf="filtering.active$ | async"></mat-progress-bar>
    <ng-container *ngFor="let item of filteredValuesSubject | async">
      <mat-option
        [class.dark-theme-bg-color]="(_currentThemeSubject | async) === 'dark'"
        *ngIf="item; else showNoData"
        [value]="item"
        [disabled]="!item || (item | disabledAutocompleteItem : disabledItemsMap)"
      >
        <ng-container
          [ngTemplateOutlet]="optionTemplate.templateRef"
          [ngTemplateOutletContext]="{ $implicit: { entity: item } }"
        ></ng-container>
      </mat-option>
      <ng-template #showNoData>
        <div class="not-found t-body-text-regular">
          {{ notFoundMessage }}
        </div>
        <mat-option *ngIf="!allowCreate" class="d-none" [disabled]="true"></mat-option>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="allowCreate && search">
      <div class="position-sticky bottom-0 bg-white">
        <div class="separator">or</div>
        <mat-option [value]="{ addNewValue: true }">
          <div class="text-center">{{ addButtonCaption }}</div>
        </mat-option>
      </div>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
